import { useQuery } from "@tanstack/react-query";

import axios from "../../../utils/axiosInceptor";
import { apiV1Endpoint } from "../endpoints";
import { ApiResponse } from "../types";

import { Organization } from "./types";

const getOrganizations = async () => {
  const url = `${apiV1Endpoint}/organization/list`;
  const response = await axios.get<ApiResponse<Organization[]>>(url);
  return response.data.result ?? [];
};

export type UseGetOrganizationsOptions = {
  isEnabled?: boolean;
};

export const useGetOrganizations = (options: UseGetOrganizationsOptions = {}) => {
  const { isEnabled = true } = options;

  const { data, isLoading, isSuccess, isError, error } = useQuery({
    queryKey: ["organizations"],
    queryFn: getOrganizations,
    enabled: isEnabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    organizations: data ?? [],
    isLoadingOrganizations: isLoading,
    isSuccessOrganizations: isSuccess,
    isErrorOrganizations: isError,
    organizationsError: error,
  };
};
